import { render, staticRenderFns } from "./CashierJournal.vue?vue&type=template&id=b88b1d70&scoped=true"
import script from "./CashierJournal.vue?vue&type=script&lang=js"
export * from "./CashierJournal.vue?vue&type=script&lang=js"
import style0 from "./CashierJournal.vue?vue&type=style&index=0&id=b88b1d70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88b1d70",
  null
  
)

export default component.exports